var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"doc-preview-container"},[_c('div',{ref:"docPreviewContent",staticClass:"doc-preview-content"},[_c('div',[_vm._v(_vm._s(_vm.emptyText))])])])}
var staticRenderFns = []

export { render, staticRenderFns }